import { Link } from 'react-router-dom';
import { BlogData } from '../../../components/context/BlogContext';

export function extractDateTime(isoString: string): { date: string; time: string } {
  const dateObj = new Date(isoString);
  const date = dateObj?.toISOString().split('T')[0];
  const time = dateObj?.toISOString().split('T')[1].split('.')[0];
  return { date, time };
}

const BlogCard = ({ blog, index }: { blog: BlogData, index: number, hide?: boolean }) => {

  const { date } = extractDateTime(blog?.publishedAt ?? new Date().toISOString());


  return (
    <div className='bg-[#18181B] rounded-lg overflow-hidden'>

      <Link
        to={`/blog/${blog?.slug} `}
        state={{ blog, index }}
        key={blog?.id}
        className="bg-zinc-900 rounded-lg overflow-hidden shadow-lg"
      >
        
        <img
          src={blog?.Image ? blog?.Image?.url : '/backdrop.jpg'}
          alt={blog?.heading}
          className="w-full h-64 object-cover"
        />

        <div className="p-4 space-x-2">

          {blog?.tags?.slice(0, 3).map((tag) => (
            <span className="bg-[#747474] text-black font-semibold text-sm px-3 py-2 rounded-full" key={tag}>
              {tag}
            </span>
          ))}

          {(!blog.tags || blog?.tags?.length == 0) && < span className='bg-[#747474] text-black font-semibold text-sm px-3 py-2 rounded-full bg-red-500 opacity-0'>Saagas</span>}

          <h3 className="text-xl font-medium mt-4 line-clamp-2">{blog?.heading}</h3>
          <p className="text-gray-400 text-sm mt-3 line-clamp-2 b">
            {blog?.blogDescription[0]?.description}
          </p>
          <div className="flex items-center mt-3 font-[600]">
            <p className="text-gray-500 text-xs mr-3">{date}</p>
          </div>
        </div>
      </Link >
    </div >
  );
};

export default BlogCard;